import apiService from 'src/shared/config/apiService';
import handleAxiosError from 'src/shared/utils/handleAxiosError';

export type CreateProductPayload = {
  rfq: number;
  name?: string;
};

export const createProduct = async (payload: CreateProductPayload) => {
  try {
    const { data } = await apiService.post(`/products/`, {
      rfq: payload.rfq,
      name: payload.name
    });

    return data;
  } catch (error) {
    throw handleAxiosError(error);
  }
};
